"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _SttInput = _interopRequireDefault(require("./SttInput"));
var _SttButton = _interopRequireDefault(require("./../SttButton/SttButton"));
var _SttAlerta = _interopRequireDefault(require("../SttAlerta"));
var _axios = _interopRequireDefault(require("axios"));
var _styles2 = _interopRequireDefault(require("./styles"));
var _excluded = ["onFileChange", "urlDownload", "urlPreAssinada", "visualizarArquivo", "file", "headers", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MYME_TYPE_ARQUIVOS = {
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS: 'application/vnd.ms-excel',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    divExterna: {
      display: 'flex',
      alignItems: 'baseline'
    },
    botaoExcluir: {
      backgroundColor: theme.palette.error.main,
      '&:hover': {
        backgroundColor: theme.palette.error.light
      }
    }
  };
});
var sttStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
function SttFileSelect(_ref) {
  var onFileChange = _ref.onFileChange,
    urlDownload = _ref.urlDownload,
    urlPreAssinada = _ref.urlPreAssinada,
    _ref$visualizarArquiv = _ref.visualizarArquivo,
    visualizarArquivo = _ref$visualizarArquiv === void 0 ? true : _ref$visualizarArquiv,
    _ref$file = _ref.file,
    file = _ref$file === void 0 ? null : _ref$file,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? null : _ref$headers,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputprops = props.inputprops,
    accept = props.accept;
  var classes = useStyles(props);
  var classesStt = sttStyles();
  var fileInput = (0, _react.useRef)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    mostrarAlerta = _useState2[0],
    setMostrarAlerta = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    tituloAlerta = _useState4[0],
    setTituloAlerta = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    mensagemAlerta = _useState6[0],
    setMensagemAlerta = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    opcoesAlerta = _useState8[0],
    setOpcoesAlerta = _useState8[1];
  var reset = function reset() {
    onFileChange(false);
  };
  var onChange = function onChange(event) {
    if (event.target.files && event.target.files[0].name) {
      onFileChange(event);
    } else {
      onFileChange(false);
    }
  };
  var openFileUrl = function openFileUrl(file, nome) {
    if (file) {
      var fileURL = URL.createObjectURL(file);
      if (file.type === MYME_TYPE_ARQUIVOS.DOC || file.type === MYME_TYPE_ARQUIVOS.DOCX || file.type === MYME_TYPE_ARQUIVOS.XLS || file.type === MYME_TYPE_ARQUIVOS.XLSX) {
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = fileURL;
        a.download = nome;
        a.click();
        URL.revokeObjectURL(fileURL);
        a.remove();
        return;
      }
      window.open(fileURL);
    }
  };
  var downloadFile = function downloadFile() {
    if (!urlDownload) {
      openFileUrl(file, file.name);
      return;
    }
    _axios["default"].get(urlDownload, {
      headers: headers,
      responseType: 'blob',
      timeout: 0
    }).then(function (response) {
      var blob = response.data;
      var file = new File([blob], inputprops.value, {
        lastModified: new Date().getTime(),
        type: blob.type
      });
      openFileUrl(file, inputprops.value);
    })["catch"](function (err) {
      setTituloAlerta('Erro');
      setMensagemAlerta('Ocorreu um erro no download do arquivo. Tente novamente mais tarde.');
      setOpcoesAlerta([{
        title: 'Ok',
        onClick: function onClick() {
          setMostrarAlerta(false);
        }
      }]);
      setMostrarAlerta(true);
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divExterna
  }, /*#__PURE__*/_react["default"].createElement(_SttInput["default"], _extends({}, inputprops, {
    value: inputprops.value ? inputprops.value : '',
    helperText: inputprops.error ? inputprops.error : "",
    error: inputprops.error ? true : false,
    variant: "outlined",
    margin: "dense",
    fullWidth: true,
    disabled: true,
    onFocus: function onFocus() {
      return fileInput.current.click();
    },
    className: classes.textFieldNome,
    InputLabelProps: {
      classes: {
        root: classesStt.label,
        focused: classesStt.focused,
        error: classesStt.error
      }
    },
    InputProps: {
      classes: {
        root: classesStt.input,
        focused: classesStt.cssfocused,
        notchedOutline: classesStt.notchedOutline,
        disabled: classesStt.disabled,
        error: classesStt.error
      }
    }
  })), !inputprops.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return fileInput.current.click();
    }
  }, "Selecionar")), /*#__PURE__*/_react["default"].createElement("input", {
    ref: fileInput,
    type: "file",
    onChange: onChange,
    onClick: function onClick(event) {
      return event.target.value = '';
    },
    style: {
      display: 'none'
    },
    accept: accept
  }), (file && file.size || urlDownload) && visualizarArquivo && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "secondary",
    onClick: downloadFile
  }, "Visualizar")), urlPreAssinada && visualizarArquivo && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return window.open(urlPreAssinada);
    }
  }, "Visualizar")), inputprops.value && !disabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
    variant: "contained",
    color: "secondary",
    onClick: reset,
    className: classes.botaoExcluir
  }, "Excluir")), /*#__PURE__*/_react["default"].createElement(_SttAlerta["default"], {
    open: mostrarAlerta,
    title: tituloAlerta,
    message: mensagemAlerta,
    type: 'error',
    onClose: function onClose() {
      setMostrarAlerta(false);
    },
    options: opcoesAlerta
  }));
}
var _default = SttFileSelect;
exports["default"] = _default;